import {
    Box,
    Card,
    CardContent,
    Grid,
    Stack,
    Tooltip,
    Typography,
  } from "@mui/material";
  import React from "react";
 
  export default function CardPaymentAppoinment({ item, setOpen, setModalData, cardKet }) {
    return (
      <Card
        sx={{
          width: "100%",
          // m: "0px",
          // mt: "10px",
          ":hover": {
            bgcolor: "#2892ba17",
          },
          cursor: "pointer",
          // p: "0rem 0.3rem",
        }}
        onClick={() => { 
        }}
      >
        <CardContent sx={{ padding: "0.5px 10px !important", margin: "10px" }}>
          <Grid container>
             <Grid item xs={6}>
                <Typography>Appointment id</Typography>
             </Grid>
  
             <Grid item xs={6}>
             <Typography> {item?.appointmentId}</Typography>
              
              </Grid>
              
              <Grid item xs={6}>
                <Typography>        Customer Name</Typography>
             </Grid>
  
             <Grid item xs={6}>
             <Typography> {item?.customerName}</Typography>
              
              </Grid>
              <Grid item xs={6}>
                <Typography>        Mobile Number  </Typography>
             </Grid>
  
             <Grid item xs={6}>
             <Typography> {item?.mobileNumber}</Typography>
              
              </Grid>
              <Grid item xs={6}>
                <Typography>        Services    </Typography>
             </Grid>
  
             <Grid item xs={6}>
             <Typography> {(function(){
                let tt=""
                item?.services?.forEach(element => {
                    tt+=element?.service+","
                });
                return tt
             })()}</Typography>
              
              </Grid>
              <Grid item xs={6}>
                <Typography>        Mobile Number  </Typography>
             </Grid>
  
             <Grid item xs={6}>
             <Typography> {item?.date?.split("T")[0]} { "  "}      {item?.date?.split("T")[1]}</Typography>
              
              </Grid>
              <Grid item xs={6}>
                <Typography>      Status</Typography>
             </Grid>
  
             <Grid item xs={6}>
             <Typography> {item?.status }</Typography>
              
              </Grid>
              
              
    
          </Grid>
        </CardContent>
      </Card>
    );
  }
  